
export const LOAD = 'items/LOAD';
export const LOAD_SUCCESS = 'items/LOAD_SUCCESS';
export const LOAD_FAIL = 'items/LOAD_FAIL';

export function isLoaded(globalState) {
  return globalState.items && globalState.items.loaded;
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get('/api/items'), // params not used, just shown as demonstration
  };
}
